import { render } from "./CustomerInvoices.vue?vue&type=template&id=f2bcc87c"
import script from "./CustomerInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__